// eslint-disable-next-line import/no-extraneous-dependencies
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/capacitor';

export const handleOrientationLock = async () => {
  try {
    const isNativePlatform = Capacitor.isNativePlatform();
    if (isNativePlatform && Capacitor.isPluginAvailable('ScreenOrientation')) {
      await ScreenOrientation.lock({ orientation: 'portrait' });
    }
  } catch (error) {
    Sentry.captureException(error);
    console.error(error);
  }
};
